import { useEffect } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { BellIcon, PageHeaderPrimary, PageLoader } from 'cat-ecommerce-alloy';
import ShoppingCartPage from './ShoppingCartPage';
import { normalizeError } from '@app/store/exception/utils';
import { MATCH_ROUTE_DEEPLINK } from './ShoppingCartPage/constants';
import {
  HEADER_STICKY_ON_SCROLL,
  SUCCESS
} from '@app/constants/commonConstants';
import { ERROR_DOMAIN, ERROR_PATH } from '@app/constants/errorConstants';
import { setError } from '@app/store/exception/actions';
import { loadShoppingCartPage } from '../../../../store/checkout/actions';
import { SHOPPING_CART_PAGE } from '@app/constants/targets';
import ShoppingCartLinks from './ShoppingCartLinks';
import Conditional from '@app/components/common/Conditional';
import { useLocation } from 'react-router-dom';
import { useModal } from '@cat-ecom/pcc-components';
import { AssociatedDealerModal } from '@app/components/associated-dealer-block';

const ShoppingCart = ({ location }) => {
  const { route } = queryString.parse(location.search);
  const dealerAssociations = useSelector(
    s => s.dealerAssociation?.dealerAssociations
  );
  const searchParams = useLocation().search;
  const { storeId, fromAbandonedCart } = queryString.parse(searchParams);
  const isShoppingCartPageLoading = useSelector(
    s => s.checkout.isShoppingCartPageLoading
  );

  const [t] = useTranslation();
  const dispatch = useDispatch();
  const associatedDealerModal = useModal({
    isRequired: true,
    backButton: false,
    size: 'md'
  });

  useEffect(() => {
    if (Boolean(fromAbandonedCart)) {
      dealerAssociations?.forEach(dealerItem => {
        if (dealerItem.value === storeId && dealerItem.default === false) {
          associatedDealerModal.modalControl.open();
        }
      });
    }
  }, [dealerAssociations, fromAbandonedCart]);
  const setCartImportMessage = shoppingCartImportModel => {
    const [{ severity }] = shoppingCartImportModel?.systemFeedBack;
    dispatch(
      setError(
        ERROR_DOMAIN.CART,
        ERROR_PATH.MAIN,
        normalizeError(null, {
          ...shoppingCartImportModel?.systemFeedBack[0],
          icon: severity === SUCCESS ? BellIcon : null,
          totalItemsAdded: shoppingCartImportModel?.totalItemsAdded
        })
      )
    );
  };
  useEffect(() => {
    if (route === MATCH_ROUTE_DEEPLINK) {
      dispatch(loadShoppingCartPage(setCartImportMessage));
    }
  }, [route, dispatch]);

  useEffect(() => {
    const ShoppingRootElement = document.getElementById(SHOPPING_CART_PAGE);
    ShoppingRootElement?.classList.add(HEADER_STICKY_ON_SCROLL);
    return () => ShoppingRootElement?.classList.remove(HEADER_STICKY_ON_SCROLL);
  }, []);

  const isCatCSR = useSelector(s => s.common?.isCatCSR) || false;

  return (
    <>
      <AssociatedDealerModal modal={associatedDealerModal} />
      {isShoppingCartPageLoading && <PageLoader />}
      <div className="shopping-cart__wrapper">
        <Conditional test={isCatCSR}>
          <ShoppingCartLinks />
        </Conditional>
        <Conditional test={!isCatCSR}>
          <ShoppingCartPage location={location} />
        </Conditional>
      </div>
      <div className="shopping-cart__wrapper--sos container d-none">
        <PageHeaderPrimary
          title={t('SHOPPINGCART_TITLE')}
          className="w-100 mb-3 mt-4"
        />
        <div className="shopping-cart__container--sos" />
      </div>
    </>
  );
};

ShoppingCart.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string
  })
};

export default ShoppingCart;
